import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingCart, ChefHat, Utensils } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    num: '1',
    title: 'Comprás',
    desc: 'Vas al súper/chino con la lista exacta que te doy.',
    icon: <ShoppingCart className="w-8 h-8 text-white" data-id="element-46" />
  }, {
    num: '2',
    title: 'Cocinás',
    desc: "Te ponés el delantal 2 horas el domingo siguiendo mi 'paso a paso' en cascada.",
    icon: <ChefHat className="w-8 h-8 text-white" data-id="element-47" />
  }, {
    num: '3',
    title: 'Disfrutás',
    desc: 'Tenés toda la semana resuelta. Solo calentás 5 minutos y listo.',
    icon: <Utensils className="w-8 h-8 text-white" data-id="element-48" />
  }];
  return <section className="py-20 px-6 bg-cream" data-id="element-49">
      <div className="max-w-5xl mx-auto" data-id="element-50">
        <div className="text-center mb-16" data-id="element-51">
          <h2 className="text-3xl md:text-4xl font-serif text-forest font-bold mb-4" data-id="element-52">
            Cómo funciona
          </h2>
          <div className="w-24 h-1 bg-terracotta mx-auto rounded-full" data-id="element-53"></div>
        </div>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-54">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-1 bg-sage -z-10 transform -translate-y-1/2" data-id="element-55"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-white rounded-2xl p-8 shadow-lg text-center relative" data-id="element-56">
              <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-12 h-12 bg-forest text-white rounded-full flex items-center justify-center font-serif font-bold text-xl border-4 border-cream" data-id="element-57">
                {step.num}
              </div>
              <div className="w-16 h-16 bg-terracotta rounded-full flex items-center justify-center mx-auto mb-6 mt-4" data-id="element-58">
                {step.icon}
              </div>
              <h3 className="text-2xl font-bold text-forest mb-3 font-serif" data-id="element-59">
                {step.title}
              </h3>
              <p className="text-brown" data-id="element-60">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}